module.exports = __webpack_public_path__ + "static/media/XVAniversario.77787b1a.jpg";